import { render, staticRenderFns } from "./order-logistics-tracking.vue?vue&type=template&id=2c01d6d2&scoped=true&"
import script from "./order-logistics-tracking.vue?vue&type=script&lang=js&"
export * from "./order-logistics-tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01d6d2",
  null
  
)

export default component.exports